var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-flex justify-center"},[_c('v-btn',{attrs:{"disabled":_vm.disabled,"icon":""},on:{"click":_vm.handleSort}},[(_vm.orderAsc)?_c('v-icon',{attrs:{"size":_vm.size}},[_vm._v(_vm._s(_vm.iconUp))]):_c('v-icon',{attrs:{"size":_vm.size}},[_vm._v(_vm._s(_vm.iconDown))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }